let api = {
    get(url) {
        //axios get man!
    }
};